import { ObjectSchema, object, string } from 'yup';
import { noop } from '@utils/noop';
import { Dispatch, createContext, useContext } from 'react';
import { UseFormReturn } from 'react-hook-form';
import * as Yup from 'yup';

export type CreateLocalizationKeyFormState = {
  localizationKey: string;
  localizationValue: string;
  language: string;
};

export const createLocalizationKeyFormStateDefault: CreateLocalizationKeyFormState = {
  localizationKey: '',
  localizationValue: '',
  language: '',
};

export const createLocalizationKeySchemaDefault: ObjectSchema<
  Partial<CreateLocalizationKeyFormState>
> = object<Partial<CreateLocalizationKeyFormState>>().shape({
  localizationKey: Yup.string()
    .test(
      'not-empty-or-spaces',
      'localization key can not be empty or just spaces',
      (value) => !!value && value.trim().length > 0
    )
    .min(2, 'localization key must be at least 2 characters')
    .required('localization key is a required field'),

  localizationValue: Yup.string()
    .test(
      'not-empty-or-spaces',
      'localization value can not be empty or just spaces',
      (value) => !!value && value.trim().length > 0
    )
    .min(2, 'localization value must be at least 2 characters')
    .required('localization value is a required field'),
  language: string().required('language is required field'),
});

type CreateLocalizationKeyFormContextType = {
  schema: ObjectSchema<Partial<CreateLocalizationKeyFormState>>;
  setSchema: Dispatch<ObjectSchema<Partial<CreateLocalizationKeyFormState>>>;
  methods?: UseFormReturn<CreateLocalizationKeyFormState>;
};

const createLocalizationKeyFormContextDefault = {
  schema: createLocalizationKeySchemaDefault,
  setSchema: noop,
} satisfies CreateLocalizationKeyFormContextType;

export const CreateLocalizationKeyFormContext = createContext<CreateLocalizationKeyFormContextType>(
  createLocalizationKeyFormContextDefault
);

export const useCreateLocalizationKeyForm = () => {
  const { methods } = useContext(CreateLocalizationKeyFormContext);
  if (!methods) {
    throw new Error('CreateLocalizationKeyFormContext is empty');
  }

  return methods;
};

export const useManageCreateLocalizationKeySchema = () => {
  const { setSchema } = useContext(CreateLocalizationKeyFormContext);

  return { setSchema };
};
